let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("huKvo")).then(() => parcelRequire('7Jw2B'));